import * as React from "react";
import SearchField from "../search-field";
export default class CategoryFilter extends React.Component {
    constructor(props) {
        super(props);
        this.searchCat = {
            'Wine': 'WINE',
            'Beer': 'BEER',
            'Liqueurs': 'LIQUEUR',
            'Spirits': 'SPIRITS',
            'Ciders & Coolers': 'CIDERS & COOLERS',
            'Other': 'NON-ALCOHOLIC'
        };
        this.changeView = (categorySelected) => {
            this.setState({ categorySelected });
        };
        this.changeVarietal = () => {
            this.setState({ viewVarietal: !this.state.viewVarietal });
        };
        this.state = {
            categorySelected: this.searchCat[this.props.category] === "WINE" ? "Varietal" : "Country",
            viewVarietal: false
        };
    }
    render() {
        let searchList;
        switch (this.state.categorySelected) {
            case "Varietal":
                let varList = [...this.props.VarietalList];
                if (varList.length > 0) {
                    varList = !this.state.viewVarietal ? varList.slice(0, 21) : varList;
                }
                varList.sort();
                searchList = searchList = (this.searchCat[this.props.category] === "WINE" || (this.props.category === 'Alberta Made' && this.props.typeSelected === 'WINE')) &&
                    varList.length > 0 ? varList.map((item, index) => {
                    return React.createElement(SearchField, { key: index, selected: this.props.currentFilter.varietal
                            .split(',')
                            .includes(item), onClick: () => { this.props.updateSubFilter(item, "ConsumerVarietal"); }, label: item });
                }) : null;
                break;
            case "Country":
                searchList = this.props.CountryList.length > 0 ? this.props.CountryList.map((item, index) => {
                    return React.createElement(SearchField, { key: index, selected: this.props.currentFilter.country
                            .split(',')
                            .includes(item.trim()), onClick: () => { this.props.updateSubFilter(item.trim(), "country"); }, label: item });
                }) : null;
                break;
            case "Region":
                searchList = this.props.RegionList.length > 0 ? this.props.RegionList.map((item, index) => {
                    return React.createElement(SearchField, { key: index, selected: this.props.currentFilter.region
                            .split(',')
                            .includes(item.trim()), onClick: () => { this.props.updateSubFilter(item.trim(), "region"); }, label: item });
                }) : null;
                break;
            case "Vintage":
                searchList = (this.searchCat[this.props.category] === "WINE" || this.searchCat[this.props.category] === "SPIRITS"
                    || (this.props.category === 'Alberta Made' && (this.props.typeSelected === 'WINE' || this.props.typeSelected === 'SPIRITS')))
                    && this.props.VintageList.length > 0 ? this.props.VintageList.map((item, index) => {
                    return React.createElement(SearchField, { key: index, selected: this.props.currentFilter.vintage
                            .split(',')
                            .includes(item), onClick: () => { this.props.updateSubFilter(item, "vintage"); }, label: item });
                }) : null;
                break;
            case "Sort": searchList = this.props.orderByOptions.length > 0 ? this.props.orderByOptions.map((item, index) => {
                return React.createElement(SearchField, { key: index, selected: this.props.currentOrderBy == item.value, onClick: () => { this.props.updateOrderBy(item.value); }, label: item.label });
            }) : null;
        }
        const countryHeader = this.props.CountryList.length > 0 ? (React.createElement("div", { className: this.state.categorySelected === "Country" ? "active" : "", onClick: () => this.changeView('Country') }, "Country")) : null;
        const regionHeader = this.props.RegionList.length > 0 ? (React.createElement("div", { className: this.state.categorySelected === "Region" ? "active" : "", onClick: () => this.changeView('Region') }, "Region")) : null;
        return (React.createElement("div", { className: "sub-filter-area" },
            React.createElement("div", { className: "category-filter" },
                React.createElement("div", { className: "filter" },
                    React.createElement("div", { className: this.state.categorySelected === 'Sort' ? 'active' : '', onClick: () => this.changeView('Sort') }, "Sort"),
                    this.searchCat[this.props.category] === "WINE" || (this.props.category === 'Alberta Made' && this.props.typeSelected === 'WINE')
                        ? React.createElement("div", { className: this.state.categorySelected === "Varietal" ? "active" : "", onClick: () => this.changeView('Varietal') }, "Varietal")
                        : null,
                    countryHeader,
                    regionHeader,
                    this.searchCat[this.props.category] === "WINE" || this.searchCat[this.props.category] === "SPIRITS"
                        || (this.props.category === 'Alberta Made' && (this.props.typeSelected === 'WINE' || this.props.typeSelected === 'SPIRITS'))
                        ? React.createElement("div", { className: this.state.categorySelected === "Vintage" ? "active" : "", onClick: () => this.changeView('Vintage') }, "Vintage")
                        : null)),
            React.createElement("div", { className: "search-field-box" }, searchList),
            (this.searchCat[this.props.category] === "WINE" || (this.props.category === 'Alberta Made' && this.props.typeSelected === 'WINE')) &&
                this.state.categorySelected === "Varietal" ?
                React.createElement("div", { className: "show-more", onClick: this.changeVarietal },
                    !this.state.viewVarietal ? "Show More" : "Show Less",
                    React.createElement("i", { className: !this.state.viewVarietal ? "fa fa-plus" : "fa fa-minus" })) : null));
    }
}
;
//# sourceMappingURL=category-filter.js.map